import React from 'react';
import "./styles.scss";

const AddNewTypeModal = ({
  isOpen,
  newTypeName,
  handleNewTypeNameChange,
  handleAddNewType,
  handleCloseAddNewTypeModal,
  handleBackFromAddNewTypeModal,
}) => {
  if (!isOpen) return null;

  return (
    <div
      id="addNewTypeModal"
      className="modal fade in example-modal"
      tabIndex="-1"
      role="dialog"
      aria-labelledby="modal-title-2"
    >
      <div className="modal-dialog" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <button
              type="button"
              onClick={handleCloseAddNewTypeModal}
              className="close"
              aria-label="Close"
            >
              &times;
            </button>
            <h4 id="modal-title-2" className="modal-title">
              Add New Type
            </h4>
          </div>
          <div className="modal-body">
            <div className="form-group">
              <label htmlFor="newTypeName" className="col-xl-4 col-sm-5 col-xs-5 control-label">
                New Type Name:
              </label>
                <input
                  id="newTypeName"
                  type="text"
                  value={newTypeName}
                  onChange={handleNewTypeNameChange}
                  className="form-control"
                />
            </div>
          </div>
          <div className="modal-footer">
          <button
              className="btn btn-primary"
              onClick={handleAddNewType}
              disabled={!newTypeName.trim()}
            >
              Save
            </button>
            <button className="btn" onClick={handleBackFromAddNewTypeModal}>
              Back
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddNewTypeModal;